import { cn } from "../../lib/utils";

type TagProps = {
  className?: string;
};

type DocsTagProps = TagProps & {
  href: string;
};

type RequiredTagProps = TagProps & {
  hasError?: boolean;
};

export const OptionalTag = ({ className }: TagProps) => {
  return (
    <span
      className={cn(
        "ml-2 inline-flex h-4.5 items-center rounded-[5px] border px-1.5 font-mono text-[10px] uppercase leading-none tracking-[0.06em] border-grayA-5 text-gray-10",
        className,
      )}
    >
      Optional
    </span>
  );
};

export const DocsTag = ({ className, href }: DocsTagProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "ml-2 inline-flex h-4.5 items-center rounded-[5px] border px-1.5 font-mono text-[10px] uppercase leading-none tracking-[0.06em] border-grayA-5 text-gray-11 no-underline transition-colors hover:border-grayA-7 hover:text-gray-12",
        className,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      Docs
    </a>
  );
};

export const RequiredTag = ({ className, hasError }: RequiredTagProps) => {
  return (
    <span
      className={cn(
        "ml-2 inline-flex h-4.5 items-center rounded-[5px] border px-1.5 font-mono text-[10px] uppercase leading-none tracking-[0.06em]",
        hasError ? "border-errorA-6 text-error-11" : "border-grayA-5 text-gray-10",
        className,
      )}
    >
      Required
    </span>
  );
};
